var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 503,
    viewBox: "0 0 343 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M265.644 397.593H31.429V61.671H265.58V86.801H297.052V54.811C297.073 24.677 272.331 0 242.218 0H54.833C24.677 0 0 24.677 0 54.811V447.831C0 478.009 24.677 502.664 54.833 502.664H242.218C272.331 502.664 297.073 478.009 297.073 447.831V397.01H265.644V397.593ZM148.493 475.226C134.601 475.226 123.385 463.988 123.385 450.118C123.385 436.205 134.602 424.988 148.493 424.988C162.406 424.988 173.645 436.226 173.645 450.118C173.645 463.988 162.407 475.226 148.493 475.226Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208 375C161.875 375 120.25 352.5 95.5 314.25V375H73V273.75H174.25V296.25H110.125C130.375 331.125 166.375 352.5 208 352.5C269.875 352.5 320.5 301.875 320.5 240H343C343 314.25 282.25 375 208 375ZM95.5 240H73C73 165.75 133.75 105 208 105C254.125 105 295.75 127.5 320.5 165.75V105H343V206.25H241.75V183.75H305.875C285.625 148.875 249.625 127.5 208 127.5C146.125 127.5 95.5 178.125 95.5 240Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.cdd7adf810bd25912a2ac15149093e37.svg";
export { ForwardRef as ReactComponent };